<template>
  <div class="swiper-and-login">
    <div class="swiper-box">
      <el-carousel
        trigger="click"
        height="447px"
        arrow="always"
        :autoplay="true"
        :interval="2000"
        indicator-position="none"
      >
        <el-carousel-item
          v-for="(item, index) in swiperList"
          :key="item.pictureName + index"
        >
          <img
            class="swiper-imgs"
            :src="item.pictureUrl"
            :alt="item.pictureName"
            @click="handleImg(item.pictureLink)"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="login-box">
      <template v-if="!loginState">
        <div class="login-title">账号登录</div>
        <div class="login-id">
          <img src="../../../assets/image/home-user-id-icon.png" alt="账号" />
          <input type="text" v-model="phone" placeholder="请输入账号" />
        </div>
        <div class="login-password">
          <img
            src="../../../assets/image/home-user-password-icon.png"
            alt="密码"
          />
          <input type="password" v-model="smscode" placeholder="请输入密码" />
        </div>
        <div class="login-code">
          <div>
            <img
              src="../../../assets/image/home-user-code-icon.png"
              alt="验证码"
            />
            <input type="text" v-model="kaptcha" @keyup.enter="handleSubmit" placeholder="请输入验证码" />
          </div>
          <img :src="captchUrl" alt="验证码" @click="changeCaptchUrl" />
        </div>
        <div class="login-submit" @click="handleSubmit">登录</div>
        <!-- <div class="login-forget" @click="handleForget">忘记密码？</div> -->
      </template>
      <template v-else>
        <div class="info-photo">
          <img
            :src="
              userInfo.photoUrl ||
              require('../../../assets/image/user-info-icon3.png')
            "
            alt="用户头像"
          />
          <span>{{ userInfo.nickName }}</span>
        </div>
        <div class="info-phone">
          <img src="../../../assets/image/user-info-icon1.png" alt="用户账号" />
          <span>用户账号：{{ userInfo.cardNo }}</span>
        </div>
        <div class="info-login-time">
          <img
            src="../../../assets/image/user-info-icon2.png"
            alt="上次登录时间"
          />
          <span>上次登录时间：{{ userInfo.loginTime }}</span>
        </div>
        <div class="to-manage" @click="toManage">管理中心</div>
        <div class="login-out" @click="handleLoginOut">退出登录</div>
      </template>
    </div>
  </div>
</template>
<script>
import * as API from '../../../api/home/index'
import { baseURL } from '../../../api/request'
import Cookies from 'js-cookie'
export default {
  name: 'HomeSection1',
  data() {
    return {
      swiperList: [],
      phone: '',
      smscode: '',
      kaptcha: '',
      uuid: '',
      baseURL,
      captchUrl: '',
      loginState: false,
      userInfo: {}
    }
  },
  created() {
    this.getSwiperList()
    this.getToken()
  },
  methods: {
    // 获取cookie
    getToken() {
      const token = Cookies.get('tvToken')
      if (token) {
        this.getUserInfo()
      } else {
        this.changeCaptchUrl()
      }
    },
    // 获取用户信息
    async getUserInfo() {
      const _userInfo = window.sessionStorage.getItem('tvUserInfo')
      if (_userInfo) {
        this.kaptcha = ''
        this.smscode = ''
        this.phone = ''
        this.loginState = true
        this.userInfo = JSON.parse(_userInfo)
        return
      }
      try {
        const res = await API.getUserInfo()
        const { code, data = {} } = res
        if (code === 0) {
          this.kaptcha = ''
          this.smscode = ''
          this.phone = ''
          this.loginState = true
          this.userInfo = data
          window.sessionStorage.setItem('tvUserInfo', JSON.stringify(data))
        } else {
          throw Error()
        }
      } catch (error) {}
    },
    // 随机串
    randomStr(length) {
      let _string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' // 26个大写字母
      _string += 'abcdefghijklmnopqrstuvwxyz' // 26个小写字母
      _string += '0123456789-' // 10个数字、下划线、连字符
      let _temp = ''
      const _length = _string.length - 1
      for (let i = 0; i < length; i++) {
        // 根据指定长度生成随机字符串
        const n = parseInt(Math.random() * _length) // 获取随机数字
        _temp += _string[n] // 映射成字符串
      }
      return _temp // 返回映射后的字符串
    },
    // 更换验证码
    changeCaptchUrl() {
      const str = this.randomStr(40)
      this.uuid = str
      this.captchUrl = `${this.baseURL}/auth/login/kaptcha?uuid=${str}`
    },
    async getSwiperList() {
      try {
        const params = { page: 1, limit: 8 }
        const res = await API.getHomeSection1Swiper(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.swiperList = records
        }
      } catch (error) {}
    },
    handleImg(url) {
      if (url) window.open(url)
    },
    async handleSubmit() {
      const { uuid, kaptcha, smscode, phone } = this
      if (!phone) {
        this.$message.warning('请输入账号')
        return
      }
      if (!smscode) {
        this.$message.warning('请输入密码')
        return
      }
      if (!kaptcha) {
        this.$message.warning('请输入验证码')
        return
      }
      try {
        const data = { uuid, kaptcha, smscode, phone }
        window.sessionStorage.removeItem('tvUserInfo')
        const res = await API.toLogin(data)
        const {
          code,
          data: { access_token: accessToken }
        } = res
        if (code === 0) {
          const token = accessToken
          const url = window.location.hostname
          const arr = url.split('.')
          let domain = ''
          if (arr.length > 2) {
            domain = arr.slice(arr.length - 2).join('.')
          } else {
            domain = arr.join('.')
          }
          Cookies.set('tvToken', token, {
            expires: 1,
            domain: `${
              process.env.NODE_ENV === 'development' ? domain : '.' + domain
            }`
          })
          this.getUserInfo()
        }
      } catch (error) {}
    },
    handleForget() {
      this.$router.push({
        path: '/resetPassword',
        query: {
          hideHeader: true
        }
      })
    },
    toManage() {
      // window.location.href = window.location.href.split('tvpc').join('tvui')
      if (window.location.href.indexOf('tvpc') > -1) {
        window.open(window.location.href.split('tvpc').join('tvui'))
      } else {
        window.open('https://admin.nrtatalent.cn')
      }
    },
    handleLoginOut() {
      const url = window.location.hostname
      const arr = url.split('.')
      let domain = ''
      if (arr.length > 2) {
        domain = arr.slice(arr.length - 2).join('.')
      } else {
        domain = arr.join('.')
      }
      Cookies.remove('tvToken', {
        domain: `${
          process.env.NODE_ENV === 'development' ? domain : '.' + domain
        }`
      })
      window.sessionStorage.removeItem('tvUserInfo')
      this.loginState = false
      this.getToken()
    }
  }
}
</script>
<style lang="scss" scoped>
.swiper-and-login {
  width: 1200px;
  height: 502px;
  margin-bottom: 40px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  .swiper-box {
    width: 806px;
    height: 447px;
    margin-right: 20px;
    .swiper-imgs {
      width: 100%;
      height: 100%;
    }
  }

  .login-box {
    width: 334px;
    height: 447px;
    background: #e0eaff;

    .login-title {
      height: 23px;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0861d5;
      margin: 50px 0 19px;
      text-align: center;
    }

    .login-id,
    .login-password {
      width: 300px;
      height: 48px;
      background: #eeeeee;
      border: 2px solid #0861d5;
      border-radius: 24px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      > img:first-child {
        width: 24px;
        height: 24px;
        margin: 0 12px 0 19px;
      }

      > input {
        outline: none;
        background: none;
        border: none;
        flex: 1;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;

        &::-webkit-input-placeholder {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }

        &:-moz-placeholder {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }

        &::-moz-placeholder {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }

        &:-ms-input-placeholder {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }
      }
    }

    .login-code {
      margin: 0 auto 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      > div {
        width: 202px;
        height: 48px;
        background: #eeeeee;
        border: 2px solid #0861d5;
        border-radius: 24px;
        margin-right: 6px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        > img:first-child {
          width: 24px;
          height: 24px;
          margin: 0 12px 0 19px;
        }

        > input {
          outline: none;
          background: none;
          border: none;
          flex: 1;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;

          &::-webkit-input-placeholder {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }

          &:-moz-placeholder {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }

          &::-moz-placeholder {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }

          &:-ms-input-placeholder {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }
        }
      }

      > img {
        width: 92px;
        height: 48px;
      }
    }

    .login-submit {
      width: 300px;
      height: 48px;
      background: linear-gradient(-90deg, #0651b4 0%, #517df8 100%);
      border-radius: 24px;
      margin: 0 auto 39px;
      text-align: center;
      line-height: 48px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      cursor: pointer;
    }

    .login-forget {
      font-size: 11px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      text-decoration: underline;
      color: #0036fe;
      margin-left: 19px;
      cursor: pointer;
    }
    .info-photo {
      height: 113px;
      margin: 34px 0 45px;
      > img {
        width: 113px;
        height: 113px;
        vertical-align: middle;
        margin: 0 15px 0 38px;
      }
      > span {
        display: inline-block;
        vertical-align: middle;
        width: 120px;
        word-break: break-all;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #0861d5;
        text-align: left;
      }
    }
    .info-phone,
    .info-login-time {
      // text-align: center;
      height: 20px;
      line-height: 20px;
      margin-bottom: 15px;
      > img {
        width: 18px;
        height: 17px;
        vertical-align: middle;
        margin: 0 8px 0 17px;
      }
      > span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
    }
    .info-login-time {
      margin-bottom: 40px;
    }
    .to-manage,
    .login-out {
      width: 300px;
      height: 48px;
      background: linear-gradient(-90deg, #0651b4 0%, #517df8 100%);
      border-radius: 24px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 48px;
      text-align: center;
      margin: 0 auto 20px;
      cursor: pointer;
    }
    .login-out {
      background: #ff4e4e;
    }
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }
}
</style>
